import { Dialog } from "primereact/dialog"
import colourPauseSvg from "@Assets/svg/Dashboard-svgs/colourPause.svg";
import Play from "@Assets/svg/MockTest-svgs/Play.svg";

export const PauseTestDialog = ({ Pauesedialog, setPauesedialogHandler, pauseTestHandler, resumeTestHandler }: any) => {
  return (
    <>
      <Dialog className="mock-test-dialog-box" position="top" visible={Pauesedialog} onHide={() => setPauesedialogHandler(false)} closeOnEscape={false} >
        <div className="pause-dialog-box">
          <div className="p-dlg-heading">Pause Test?</div>
          <span className="p-dilg-para">Do you really want to pause the test?</span>

          <div className="tw-mt-7 tw-flex gap-2">
            <button className="ia-btn ia-btn-outline-primary" onClick={() => pauseTestHandler()} ><img src={colourPauseSvg} alt="colourPauseSvg" /> Pause Test</button>
            <button className="ia-btn ia-btn-primary" onClick={() => resumeTestHandler()}><img src={Play} alt="Play-Svg" style={{ width: '12px' }} />Resume Test</button>
          </div>
        </div>
      </Dialog></>
  )
}